export default __webpack_public_path__ + "static/media/icaew_grid_xl.3223581d.jpg";